module.exports = __webpack_public_path__ + "static/phones-c9646642aaf8c25c47a58acf71436554.png";